<app-modal-base
  [title]="'API.revokeApiKey' | translate"
  [showCloseIcon]="true"
  [primaryButtonText]="'API.revoke' | translate"
  [primaryButtonVariant]="'danger'"
  [showSecondaryButton]="false"
  (close)="dialogRef.close(false)"
  (primaryClick)="dialogRef.close(true)"
>
  <label
    class="modal-body-text mb-0 [&&]:font-normal text-black"
    [innerHTML]="'API.revokeApiKeyConfirmation' | translate: { apiKey: data.apiKey }"
  >
  </label>

  <app-alert-message type="danger" [message]="'API.revokeApiKeyWarning' | translate"></app-alert-message>
</app-modal-base>
